module.exports = __webpack_public_path__ + "static/media/waterOn.aefb1824.svg";